import { Modal } from "reactstrap";
import { between, up } from "styled-breakpoints";
import styled from "styled-components";


export const CustomModal = styled(Modal)`
    max-width: 637px;
    --bs-modal-width: 566px;
    border-radius: 22px;
    font-family: Archivo;
    
    .modal-content {
        padding: 20px !important;

        overflow-y: scroll;
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
        max-height: 100vh;
        ${up("md")} {
            padding: 36px !important;
            border-radius: 22px;
            max-height: 90vh;
        }
    }
    .modal-content::-webkit-scrollbar {
        display: none;
    }
    .modal-header {
        padding-bottom: 0;
        padding-top: 0;
        border-bottom: none !important;
        justify-content: center;
        align-items: center;
        h5 {
            font-weight: 700;
            font-style: Bold;
            leading-trim: NONE;
            line-height: 100%;
            letter-spacing: 0px;
            text-transform: capitalize;
            font-size: 17px;
            
            ${up("md")} {
                font-size: 24px;
                
            }

            span.green {
                color: rgba(11, 156, 7, 1);
            }
        }
        .btn-close {
            display: none;
        }
        .close-btn {
            position: absolute;
            top: 7px;
            ${up("md")} {
                top: 10px;
            }
            right: 16px;
            cursor: pointer;
        }
        .close-rounded-btn {
            position: absolute;
            top: 4px;
            background-color: #F5F5F4;
            
            ${up("md")} {
                top: 7px;
            }
            left: 4px;
            cursor: pointer;
        }
    }
    .modal-body {
        .form-label {
            font-weight: 500;
            font-size: 16px;
        }
        .mb-3 {
            margin-bottom: 1.5rem !important;
        }
        .input-group {
            .input-group-text {
                border-radius: 50px;
                background-color: unset;
                border: 1px solid #262626;
                border-right: none;
                padding-right: 0;
            }
            .form-control {
                border: 1px solid #262626;
                border-left: 0;
                border-radius: 50px;
                padding: 14px;
                padding-left: 8px;
            }
            .form-control:focus {
                box-shadow: none;
            }
        }
        textarea.form-control {
            border-radius: 25px;
            padding: 20px;
            border: 1px solid #262626;
        }
        textarea.form-control:focus {
            box-shadow: none;
            border-color: unset;
        }
    }
    .modal-footer {
        border-top: none !important;
        justify-content: center;
        button {
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 36px;
            background: #0b9c07;
            padding: 8.5px;
            font-weight: 600;
            font-size: 14px;
            width: 100%;
            svg {
                margin-left: 4px;
            }
        }
    }
`;
